import { useShopStore } from "@/store";
import type { RouteLocationNormalized } from "vue-router";

export function getShopId(route?: RouteLocationNormalized) {
  const shopStore = useShopStore();
  try {
    // 如果提供了路由对象，优先从路由查询参数中获取
    if (route?.query?.shop) {
      const shop = route.query.shop as string;
      shopStore.setShopId(shop?.split('.')[0]);
      return shop;
    }

    // 如果没有传 route（或 route 没有 shop），从地址栏解析 shop 参数
    // 兼容 history 模式：/path?shop=xxx
    // 兼容 hash 模式：/#/path?shop=xxx
    if (typeof window !== "undefined") {
      const href = window.location.href;
      const url = new URL(href);
      const directShop = url.searchParams.get("shop");
      if (directShop) {
        shopStore.setShopId(directShop.split(".")[0]);
        return directShop;
      }
      const hash = url.hash || "";
      const hashQueryIndex = hash.indexOf("?");
      if (hashQueryIndex >= 0) {
        const hashQuery = hash.slice(hashQueryIndex + 1);
        const hashShop = new URLSearchParams(hashQuery).get("shop");
        if (hashShop) {
          shopStore.setShopId(hashShop.split(".")[0]);
          return hashShop;
        }
      }
    }
    
    // 如果路由中没有 shop 参数，尝试从 store 中获取
    if (shopStore.shopId) {
      return shopStore.shopId.split(".")[0];
    }
    
    // 如果都没有，返回空字符串
    return "";
  } catch (error) {
    console.error('Error in getShopId:', error);
    return shopStore.shopId || "";
  }
}
